import { type InputCapture } from '@canvas/input';
import type { PointerDownCapture, PointerMoveCapture } from '@canvas/input/types/pointer';

import { type SelectionMachine } from '../../machine/selection-machine';

import { dispatchInitialClick } from './dispatch-initial-click';
import { type ClickTarget } from './get-click-target';

export interface MouseState {
  onPointerDown(event: PointerDownCapture): MouseState;
  onPointerMove(event: PointerMoveCapture): MouseState;
  onPointerUp(): MouseState;
}

export function createIdleState(
  machine: SelectionMachine,
  inputCapture: InputCapture,
  getClickTarget: (x: number, y: number) => ClickTarget
): MouseState {
  const idleState: MouseState = {
    onPointerUp: () => idleState,
    onPointerMove: () => idleState,
    onPointerDown: (event) => {
      const { x, y } = event.properties;
      const target = getClickTarget(x, y);

      if (target.type === 'none') {
        return idleState;
      }

      const hasShift = inputCapture.hasKeyModifierPressed('Shift');

      dispatchInitialClick(machine, target, hasShift);

      //TODO: Check for returning dragging State

      return idleState;
    },
  };

  return idleState;
}
